import styled from 'styled-components';

import colors from 'utils/colors';

import { MenuColumnTheme } from '../../interfaces';

type NavItemProps = { colorScheme: MenuColumnTheme; isActive: boolean };

const getBackgroundColor = (props: NavItemProps) => {
  const { isActive, colorScheme } = props;
  if (isActive) {
    switch (colorScheme) {
      case MenuColumnTheme.BLUE_GREY:
        return colors.blueGrey75;
      case MenuColumnTheme.BLUE_GREY_75:
        return colors.darkGrey75;
      case MenuColumnTheme.DARK_GREY:
      default:
        return colors.blueGrey;
    }
  } else {
    return 'none';
  }
};

export const NavItem = styled.div<{ colorScheme: MenuColumnTheme; isActive: boolean }>`
  width: 100%;
  padding: 0px 48px;
  box-sizing: border-box;

  background-color: ${getBackgroundColor};

  &:focus-within {
    background-color: ${getBackgroundColor};
  }

  a,
  button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 24px 0;
    position: relative;

    &:hover {
      cursor: pointer;
    }

    &:focus {
      text-decoration: underline;
    }

    &:after {
      display: block;
      position: absolute;
      top: auto;
      bottom: 0;
      content: '';
      width: 100%;
      height: 1px;
      background-color: ${props => {
        const { colorScheme } = props;
        switch (colorScheme) {
          case MenuColumnTheme.BLUE_GREY:
            return colors.blueGrey75;
          case MenuColumnTheme.BLUE_GREY_75:
            return colors.white;
          case MenuColumnTheme.DARK_GREY:
          default:
            return colors.blueGrey;
        }
      }};
    }
  }

  &:last-child {
    a,
    button {
      &:after {
        display: none;
      }
    }
  }
`;

export const NavLink = styled.a`
  text-decoration: none;
  color: inherit;
  
  &:hover {
    span {
      text-decoration: underline;
    }
  }

  &:focus {
    outline: none;
  }
`;

export const LinkText = styled.span`
  font-family: VIC;
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${colors.white};
  text-decoration: none;
`;

export const IconWrapper = styled.div`
  flex-shrink: 0;
  margin-left: 1rem;
  height: 30px;
  width: 30px;

  svg {
  }
`;

export const IconWrapperOutline = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 1rem;
  height: 30px;
  width: 30px;
  border: 1px solid ${colors.white};
  border-radius: 50%;
  position: relative;

  svg {
    height: 8px;
    width: 14px;

    path {
      fill: ${colors.white};
    }
  }
`;
